export * from './link';
export { createOperation, makePromise, toPromise, fromPromise, fromError, } from './linkUtils';
import Observable from 'zen-observable-ts';
export { Observable };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@absinthe/socket-apollo-link/~/apollo-link/lib/index.js
// module id = 1002
// module chunks = 2